import React, { Props } from "react"
import { Modal } from "@fourkites/elemental-modal"
import { Trans, useTranslation } from "react-i18next"

const TimeoutModal = React.memo((props: any) => {
  const { t } = useTranslation()
  return (
    <Modal
      title=""
      customHeader={
        <div className="header-container">
          <span>
            <img
              src={props.Warning}
              alt="warning-icon"
              className="alert-icon"
            />
            Warning
          </span>
          <span
            className="close-icon"
            onClick={() => props.handleStayLoggedIn()}
          >
            X
          </span>
        </div>
      }
      show={props.showModal}
      size="large"
      onClose={() => props.Logout()}
      onSave={() => props.handleStayLoggedIn()}
      saveLabel={t("save_session") || ""}
      closeLabel={t("logout") || ""}
    >
      <div className="modal-container">
        <p>
          {t("hey")} {props.driverObj}, {t("waiting_arsession_about_to_expire")}
        </p>
        <p>
          {t("you_will_be_logged_out")}
          <span className="counter-text">{` ${props.seconds}`}</span>{" "}
          {t("seconds")}.
        </p>
        <div className="warning-info" style={{ width: "auto" }}>
          <img className="warning-info-img" src={props.info} alt="info" />
          <div
            className="warning-info-text"
            style={{
              float: "none",
              display: "flex"
            }}
          >
            <Trans
              i18nKey="progress_has_been_saved"
              components={{ newLine: <br /> }}
            />
          </div>
        </div>
      </div>
    </Modal>
  )
})

export default TimeoutModal
